var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-component" }, [
    _c(
      "form",
      {
        staticClass: "search-form",
        attrs: { action: "#", method: "get" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.onSubmit($event)
          }
        }
      },
      [
        _c("div", { staticClass: "input-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.input,
                expression: "input"
              }
            ],
            staticClass: "search-input",
            attrs: {
              type: "search",
              name: "input",
              placeholder: _vm.inputPlaceholder,
              autocomplete: "off"
            },
            domProps: { value: _vm.input },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.input = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "input-group-append" }, [
            _c(
              "button",
              { staticClass: "btn", attrs: { type: "submit" } },
              [_c("icon", { attrs: { name: "search" } })],
              1
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "ul",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showResult,
            expression: "showResult"
          }
        ],
        staticClass: "list search-result-list"
      },
      [
        _vm._l(_vm.result, function(item) {
          return _vm._t(
            "result-item",
            [
              _c(
                "li",
                {
                  key: item._id,
                  attrs: { tabindex: "0" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.onClickItem(item)
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(item.name) + "\n      ")]
              )
            ],
            { item: item, onClickItem: _vm.onClickItem }
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }